import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import BasicUserLink from '../_partials/BasicUserLink';
import BasicUserName from '../BasicUserName';
import s from './UserLink.scss';
export const UserLink = (_param)=>{
    var { user, showSymbol, symbolClassName, useCoreRibbon, coreRibbonClassname, usernameClassName, className, children } = _param, rest = _object_without_properties(_param, [
        "user",
        "showSymbol",
        "symbolClassName",
        "useCoreRibbon",
        "coreRibbonClassname",
        "usernameClassName",
        "className",
        "children"
    ]);
    const isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "UserLink"
    }, /*#__PURE__*/ React.createElement(BasicUserLink, _object_spread({
        user: user,
        className: c(className, useCoreRibbon && s['with-svg-core-badge'])
    }, rest), children ? children : /*#__PURE__*/ React.createElement(BasicUserName, {
        user: user,
        showSymbol: showSymbol,
        symbolOpensPopup: !isMobile,
        symbolClassName: symbolClassName,
        useCoreRibbon: useCoreRibbon,
        coreRibbonClassname: coreRibbonClassname,
        usernameClassName: usernameClassName
    })));
};
UserLink.displayName = 'UserLink';
export default UserLink;
